import { render } from "./TeammateProfile.vue?vue&type=template&id=3577db5a&scoped=true&ts=true"
import script from "./TeammateProfile.vue?vue&type=script&lang=ts"
export * from "./TeammateProfile.vue?vue&type=script&lang=ts"

import "./TeammateProfile.vue?vue&type=style&index=0&id=3577db5a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3577db5a"]])

export default __exports__